export default "/images/6052f8b8e663744a586b9d6c3d5c213b.png";